import { defineStore } from 'pinia'
import { UsersApi } from '@/api/users_api'

export const useUserStore = defineStore('users', {
	state: () => ({
		users: [],
	}),
	actions: {
		async initializeUsers() {
			const data = await UsersApi.getUsers()
			this.users = data ?? []
		}
	},
})
